import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "app-wrapper",
  style: {
    "display": "flex"
  }
};
import useStore from '@/store';
import { ref } from 'vue';
import Setting from './components/setting/Setting.vue';
import Sidebar from './components/sidebar/Sidebar.vue';
import AppMain from './components/app-main/AppMain.vue';
import TagsView from './components/tags-view/TagsView.vue';
import Navbar from './components/nav-bar/Navbar.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Layout',
  setup: function setup(__props) {
    var store = useStore();
    var needTagsView = ref(store.setting.tagsView);
    var fixedHeader = ref(store.setting.fixedHeader);
    var showSettings = ref(store.setting.showSettings);
    return function (_ctx, _cache) {
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Sidebar, {
        class: "sidebar-container"
      }), _createElementVNode("div", {
        class: _normalizeClass([{
          hasTagsView: needTagsView.value
        }, "main-container"]),
        style: {
          "flex": "1"
        }
      }, [_createElementVNode("div", {
        class: _normalizeClass({
          'fixed-header': fixedHeader.value
        })
      }, [_createVNode(Navbar), needTagsView.value ? (_openBlock(), _createBlock(TagsView, {
        key: 0
      })) : _createCommentVNode("", true)], 2), _createVNode(_component_XFlexCtx, {
        flex: 1
      }, {
        default: _withCtx(function () {
          return [_createVNode(AppMain)];
        }),
        _: 1
      }), showSettings.value ? (_openBlock(), _createBlock(Setting, {
        key: 0
      })) : _createCommentVNode("", true)], 2)]);
    };
  }
});